import React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import AccessGroupsList from "./AccessGroupsList.js";

export const AccessGroupsPage = (props) => {
    let { path } = useRouteMatch();
    return <Switch>
        <Route path={`${path}/group/:group_id/:sub`}><AccessGroupsList {...props} /></Route>
        <Route path={`${path}/group/:group_id`}><AccessGroupsList {...props} /></Route>
        <Route path={`${path}/tag/:tag_id`}><AccessGroupsList {...props} /></Route>
        <Route path={`${path}/`}><AccessGroupsList {...props} /></Route>
    </Switch>
}

export default AccessGroupsPage;
